import React, { useEffect, useRef } from 'react';
import { assets } from '../constants/theme';

export default function ParallaxSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    // Reveal text block
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.1 });

    const el = document.getElementById('parallax-text');
    if (el) observer.observe(el);

    return () => observer.disconnect();
  }, []);

  const s = {
    section: {
      position: 'relative',
      height: '80vh', // Significant height to allow scrolling past
      minHeight: '600px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    // The fixed background creates the parallax stretching effect
    // By fixing the attachment, the image stays still while the user scrolls
    background: {
      position: 'absolute',
      inset: 0,
      backgroundImage: `url('${assets.parallaxBeans}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed', // This is the core parallax magic
      zIndex: 1,
    },
    overlay: {
      position: 'absolute',
      inset: 0,
      backgroundColor: 'rgba(28, 18, 9, 0.45)', // Var charcoal with opacity
      zIndex: 2,
    },
    contentBox: {
      position: 'relative',
      zIndex: 3,
      backgroundColor: 'rgba(255, 255, 255, 0.95)', // Clean white box over dark beans
      padding: '5rem 6%',
      maxWidth: '800px',
      textAlign: 'center',
      boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    },
    text: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(1.8rem, 3vw, 2.4rem)',
      fontWeight: 300,
      lineHeight: 1.4,
      color: '#1C1209', // charcoal
    }
  };

  return (
    <section id="parallax" style={s.section}>
      <div style={s.background} aria-hidden="true" />
      <div style={s.overlay} aria-hidden="true" />
      
      <div style={s.contentBox}>
        {/* Paragraph from Squarespace snippet */}
        <p id="parallax-text" className="preFade" style={s.text}>
          Every coffee we roast is selected for character and clarity in the cup - 
          then developed carefully to highlight what makes it distinct.
        </p>
      </div>
    </section>
  );
}
